<template>
  <span
    v-if="content"
    class="flex flex-wrap justify-center align-center whitespace-nowrap bg-coral-main rounded-full text-white text-xs font-normal px-1"
    style="min-width: 16px; min-height: 16px"
  >
    {{ content }}
  </span>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  setup() {},
};
</script>

<style scoped></style>
